export const addCompanyToUrl = (airline: string, pathname: string) => {
  const pathnameArr = pathname.split('/');
  pathnameArr[3] = `${airline.toLocaleLowerCase().replace(/\s/g, '-')}-${pathnameArr[3]}`;
  return pathnameArr.join('/');
};

export const addCompanyToUrlVex = (airline: string, pathname: string, hostPath: string | undefined) => {
  const route = pathname.split('/').pop();
  return `${hostPath || '/vn/ve-may-bay'}/${airline.toLocaleLowerCase().replace(/\s/g, '-')}-${route}`;
};
